<template>
    <div id="google-search-bar">
        <div class="icon-gsearch">
            <i class="material-icons">search</i>
        </div>
        <input type="text" name="gsearch-text" id="gsearch-text" class="gsearch-text">
        <b-form-select
            @input="onChangeComboDistance"
            name="gsearch-distance" id="gsearch-distance" v-model="distance">
            <option value="500">500m</option>
            <option value="1000">1km</option>
            <option value="5000">5km</option>
            <option value="10000">10km</option>
        </b-form-select>
    </div>
</template>
<script>
export default {
    'name': "SearchBar",
    data() {
       return {
           distance: 500,
           place: undefined
       }
    },
    mounted() {
        var self = this;
        setTimeout(() => {
            var input = document.getElementById("gsearch-text");
            window.mainAutcomplete = new google.maps.places.Autocomplete(input);
            window.mainAutcomplete.setComponentRestrictions({ country: "CO" });
            window.mainAutcomplete.addListener('place_changed', function() {
                self.place = this.getPlace();
                self.$emit("onAutocompletePlaceChanged", self.place, self.distance);
            });
        }, 3000);
    },
    methods: {
        onChangeComboDistance() {
            var self = this;
            setTimeout(()=>{ if (self.place) self.$emit("onAutocompletePlaceChanged", self.place, parseInt(self.distance)); }, 500);
        }
    }
}
</script>
<style lang="scss">
    @import "@/assets/css/constants.scss";
</style>


